import { Database, GitBranch } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { fmtDate } from "./constants";

export function StagingTab({ staging, logs }) {
  return (
    <>
      <Card className="border-slate-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm flex items-center gap-2"><Database className="w-4 h-4" aria-hidden="true" /> Staging area (dati normalizzati/minimizzati, nessuna PII)</CardTitle>
        </CardHeader>
        <CardContent className="p-0 overflow-x-auto">
          <Table data-testid="staging-table">
            <TableHeader>
              <TableRow><TableHead>Ricevuto</TableHead><TableHead>Tipo record</TableHead><TableHead>Mapping</TableHead><TableHead>Validazione</TableHead><TableHead>Import</TableHead><TableHead>Errore</TableHead></TableRow>
            </TableHeader>
            <TableBody>
              {staging.length === 0 && (
                <TableRow><TableCell colSpan={6} className="text-center text-slate-500 py-6" data-testid="staging-empty">Staging vuota: esegui una sincronizzazione dal tab Sync.</TableCell></TableRow>
              )}
              {staging.map((r) => (
                <TableRow key={r.id} data-testid={`staging-row-${r.id.slice(0, 8)}`}>
                  <TableCell className="text-xs text-slate-600">{fmtDate(r.received_at)}</TableCell>
                  <TableCell className="text-sm font-medium">{r.external_record_type}{r.mock ? " · MOCK" : ""}</TableCell>
                  <TableCell><Badge variant="outline" className={r.mapping_status === "TO_REVIEW" ? "bg-red-100 text-red-800 border-red-300 text-[10px]" : "bg-green-100 text-green-800 border-green-300 text-[10px]"}>{r.mapping_status}</Badge></TableCell>
                  <TableCell className="text-xs">{r.validation_status}</TableCell>
                  <TableCell className="text-xs">{r.import_status}</TableCell>
                  <TableCell className="text-xs text-red-700 max-w-[220px] truncate">{r.error_message || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
      <Card className="border-slate-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm flex items-center gap-2"><GitBranch className="w-4 h-4" aria-hidden="true" /> Log di sincronizzazione</CardTitle>
        </CardHeader>
        <CardContent className="p-0 overflow-x-auto">
          <Table data-testid="jt-logs-table">
            <TableHeader><TableRow><TableHead>Data</TableHead><TableHead>Evento</TableHead><TableHead>Esito</TableHead><TableHead>Dettagli</TableHead></TableRow></TableHeader>
            <TableBody>
              {logs.length === 0 && (
                <TableRow><TableCell colSpan={4} className="text-center text-slate-500 py-6" data-testid="logs-empty">Nessuna attività registrata.</TableCell></TableRow>
              )}
              {logs.map((l) => (
                <TableRow key={l.id}>
                  <TableCell className="text-xs text-slate-600">{fmtDate(l.timestamp)}</TableCell>
                  <TableCell className="text-sm">{l.evento}</TableCell>
                  <TableCell className="text-sm">{l.esito}</TableCell>
                  <TableCell className="text-xs text-slate-500">{l.dettagli || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </>
  );
}
